import { Button } from '@mui/material'
import React, { useCallback } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNavigate, useParams } from 'react-router-dom'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners/types'
import { Banner } from 'src/Components/banner'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import { useUserSettings } from 'src/Hooks'
import useModals from 'src/Hooks/useModals'
import { ExtensionTypes, getContractStates, useInstallationExtensionData } from 'src/Libs/installation-extensions'
import useStyles from './styles'
import { K1Information } from '@e3dc-react/icons'

const ContinueAi360TariffOrderBanner: React.FC = () => {
  const { classes } = useStyles({ xlBackgroundOffsetY: -72, lgBackgroundOffsetY: -62 })
  const { t } = useCustomTranslation()
  const { userSettings } = useUserSettings()
  const { pageActions } = useNewRelic()
  const navigate = useNavigate()
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const { openAi360PowerFixModal, openAi360PowerShareModal } = useModals()
  const { installationExtensionsState, isLoading } = useInstallationExtensionData(installationId)
  const contractStates = getContractStates(installationExtensionsState)
  const tariffType = userSettings.ai360SmartMeterOrder?.tariffType

  /* Take the user back to the extensions page and reopen the details of the ai360 tariff they were ordering a smart meter for.
   * ai360PowerFix/ai360PowerShare can be ordered regardless of any other active tariff, so hasActiveTariff is always false here. */
  const openTariffDetails = useCallback(() => {
    pageActions.componentClicked({
      componentName: 'ContinueAi360TariffOrderBanner',
      userId: userSettings.userid?.toString(),
    })

    navigate(`/installation-extensions/${installationId}/${storageId}`)

    if (tariffType === ExtensionTypes.Ai360PowerFix) {
      openAi360PowerFixModal({ extensionState: contractStates.ai360PowerFixState, hasActiveTariff: false, isLoading })
    } else if (tariffType === ExtensionTypes.Ai360PowerShare) {
      openAi360PowerShareModal({ extensionState: contractStates.ai360PowerShareState, hasActiveTariff: false, isLoading })
    }
  }, [
    pageActions,
    userSettings.userid,
    navigate,
    installationId,
    storageId,
    tariffType,
    openAi360PowerFixModal,
    openAi360PowerShareModal,
    contractStates,
    isLoading,
  ])

  return (
    <Banner
      bannerKey={BannerKey.ContinueAi360TariffOrderBanner}
      button={
        <Button className={classes.infoButton} onClick={openTariffDetails}>
          {t('installation-extension.banner.order-smart-meter.continue')}
        </Button>
      }
      i18nKey="installation-extension.banner.order-smart-meter.text"
      textStyle={classes.text}
      containerStyle={classes.containerStyle}
      closeType={BannerCloseTypes.permanentOrTemporary}
      closeActionStyle={classes.closeActionStyle}
      icon={<K1Information sx={{ color: '#FFE96B', fontSize: 30 }} />}
    />
  )
}

export default ContinueAi360TariffOrderBanner
